import { useEffect, useState } from "react";
import axiosInstance from "../../config/axiosInstance";
import { useAuth } from "../../context/userContext";
import "../../css/fontawesome.css";
import AnimatedPage from "../FramerMotion/AnimatedPage";
import PageTitle from "../Misc/PageTitle";
import Navbar from "../Navbar/Navbar";

function SharePoints({ baseURL, clientID, currency }) {
    const [customerData, setCustomerData] = useState({});
    const [userData, setUserData] = useState({});
    const [rangeValue, setRangeValue] = useState(0);
    const [pointsToRedeem, setPointsToRedeem] = useState(0);
    const [calculatedPoints, setCalculatedPoints] = useState(0);
    const [customerShareExist, setCustomerShareExist] = useState(true);
    const { authUser } = useAuth();

    useEffect(() => {
        if (authUser) {
            getCustomerData(baseURL);
            setUserData(authUser);
        }
    }, [authUser]);

    useEffect(() => {
        if (pointsToRedeem > 0) {
            getCalculatedPoints();
        } else {
            setCalculatedPoints(0);
        }
    }, [pointsToRedeem]);

    const getCalculatedPoints = async () => {
        try {
            const payLoad = {
                DATA: {
                    AUTH_KEY: "TXlDb206TG95QVBJMTIz",
                    CUST_CODE: authUser?.CUST_CODE || "",
                    MOBILE_NUM: authUser?.MOBILE || "",
                    TYPE_NAME: "CAL_POINTS",
                    POINTS: pointsToRedeem,
                    CLIENT_ID: clientID,
                },
            };

            const response = await axiosInstance.post(`${baseURL}/CalculatePoints`, payLoad);

            if (response?.data?.STATUS) {
                setCalculatedPoints(response.data.REEDEEM_AMOUNT);
            } else {
                console.error(response.data?.MESSAGE || "Calculation failed");
            }
        } catch (error) {
            console.error("Error in getCalculatedPoints:", error.message || error);
        }
    };

    const getCustomerData = async (baseURL) => {
        try {
            const payLoad = {
                DIV_DES: "",
                DIV_ID: "1",
                FUNCTION: "GetLoyPoints",
                SEND_KEY: "123456",
                DATA: {
                    AUTH_KEY: "TXlDb206TG95QVBJMTIz",
                    TYPE_NAME: "CUSTOMER",
                    MOBILE_NUM: authUser?.MOBILE || "",
                    CLIENT_ID: clientID,
                },
            };

            const response = await axiosInstance.post(`${baseURL}/GetLoyPoints`, payLoad);

            if (response?.data) {
                setCustomerData(response.data);
                // Initialize points to redeem with 10% of available points
                // const initialPoints = Math.floor(response.data.CURRENTPOINTS * 0.1);
                setPointsToRedeem(0);
                setRangeValue(0); // Set slider to 10%
            }
        } catch (error) {
            console.error("Error in getCustomerData:", error.message || error);
        }
    };

    const submitShareForm = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        
        // Validate points
        if (pointsToRedeem <= 0) {
            alert("Please enter a valid amount of points to share");
            return;
        }
        
        if (pointsToRedeem > customerData.CURRENTPOINTS) {
            alert("You don't have enough points to share");
            return;
        }

        const payLoad = {
            DATA: {
                EMAIL_SENDER: customerData.Email,
                MOBILE_NUM_SENDER: customerData.MOBILE,
                EMAIL_RECEIVER: formData.get("recipient_email"),
                MOBILE_NUM_RECEIVER: formData.get("recipient_mobile"),
                SHARE_POINTS: pointsToRedeem,
                CLIENT_ID: clientID,
            },
        };

        try {
            const response = await axiosInstance.post(`${baseURL}/LoySharePoints`, payLoad);

            if (response?.data?.STATUS) {
                setCustomerShareExist(true);
                alert("Points shared successfully!");
                // Refresh customer data to update points balance
                getCustomerData(baseURL);
            } else {
                setCustomerShareExist(false);
                alert(response.data?.MESSAGE || "Failed to share points");
            }
        } catch (error) {
            console.error("Error in submitShareForm:", error);
            alert("An error occurred. Please try again.");
        }
    };

    const handleInput = (event) => {
        let value = parseInt(event.target.value) || 0;
        const maxPoints = customerData.CURRENTPOINTS || 0;
        
        // Ensure value is within bounds
        value = Math.min(Math.max(value, 0), maxPoints);
        
        setPointsToRedeem(value);
        
        // Update slider position based on percentage
        if (maxPoints > 0) {
            const percentage = Math.floor((value / maxPoints) * 100);
            setRangeValue(percentage);
        }
    };

    const handlePoints = (change) => {
        const maxPoints = customerData.CURRENTPOINTS || 0;
        let newValue = parseInt(pointsToRedeem) + change;
        
        // Ensure value is within bounds
        newValue = Math.min(Math.max(newValue, 0), maxPoints);
        
        setPointsToRedeem(newValue);
        
        // Update slider position based on percentage
        if (maxPoints > 0) {
            const percentage = Math.floor((newValue / maxPoints) * 100);
            setRangeValue(percentage);
        }
    };

    const handleRangeValueChange = (event) => {
        const percentage = parseFloat(event.target.value);
        setRangeValue(percentage);
        
        const maxPoints = customerData.CURRENTPOINTS || 0;
        const result = Math.floor((percentage / 100) * maxPoints);
        setPointsToRedeem(result);
    };

    const sliderSteps = (() => {
        const points = Number(customerData?.CURRENTPOINTS);
        if (isNaN(points) || points <= 0) return [0, 25, 50, 75, 100];

        return [0, 25, 50, 75, 100]; // Percentage values for the slider
    })();

    const getStepPoints = (percentage) => {
        const points = Number(customerData?.CURRENTPOINTS);
        if (isNaN(points)) return 0;
        return Math.floor((percentage / 100) * points);
    };

    return (
        <AnimatedPage>
            <div className="position-sticky z-2">
                <div className={"transition-0-5-bounce"}>
                    <PageTitle hideBackButton={false} name="SEND POINTS">
                        <div className="w-95 mx-auto d-flex justify-content-between mt-3 font-size-13 text-white flex-wrap" style={{ gap: "10px" }}>
                            {[
                                {
                                    label: "Points balance",
                                    value: customerData?.CURRENTPOINTS || "00",
                                },
                                {
                                    label: "Points value",
                                    value: `${customerData?.POINTS_VALUE || "0"} ${currency || "AED"}`,
                                },
                                {
                                    label: "Your type",
                                    value: userData?.CARD_TYPE || "",
                                },
                            ].map(({ label, value }, idx) => (
                                <div
                                    key={idx}
                                    className="bg-blur py-2 px-3 rounded-3 d-flex flex-column align-items-center justify-content-center text-center"
                                    style={{
                                        minWidth: "100px",
                                        flex: "1 1 calc(33.333% - 10px)",
                                        maxWidth: "calc(33.333% - 10px)",
                                    }}
                                >
                                    <p className="font-weight-400 m-0 font-size-10">{label}</p>
                                    <p className="font-weight-700 m-0">{value}</p>
                                </div>
                            ))}
                        </div>
                    </PageTitle>
                </div>
            </div>
            <form className="px-3 position-relative mh-80dvh bg-wafaa-white-3 overflow-scroll" onSubmit={(event) => submitShareForm(event)}>
                <div className="bg-wafaa-white-2 shadow-wafaa-bg p-3 rounded-3 mt-4">
                    <div className="d-flex align-items-center gap-2 mb-3">
                        <div className="rounded-2 d-flex align-items-center justify-content-center gap" style={{ backgroundColor: "#E8E9F4", width: "30px", height: "30px" }}>
                            <span className="fa-regular fa-user text-wafaa-purple font-size-13"></span>
                        </div>
                        <p className="font-size-16 font-weight-800 text-wafaa-black-1 m-0">Recipient Details</p>
                    </div>
                    <div className="mb-4">
                        {/* Email Field */}
                        <div className="mb-3">
                            <div className="d-flex align-items-center text-wafaa-grey mb-1">
                                <span className="fa-regular fa-envelope font-size-13 me-1"></span>
                                <label className="font-size-14  font-weight-600 m-0 text-wafaa-black-1 mb-0 opacity-75 ">Email Address</label>
                            </div>
                            <input className="bg-transparent text-wafaa-black-2 border text-wafaa-border p-2 px-3 w-100 rounded-3" required name="recipient_email" type="email" placeholder="friend@example.com" />
                        </div>

                        {/* Mobile Number Field */}
                        <div>
                            <div className="d-flex align-items-center text-wafaa-grey mb-1">
                                <span className="fa-solid fa-phone font-size-13 me-1"></span>
                                <label className="font-size-14  font-weight-600 m-0 text-wafaa-black-1 mb-0 opacity-75 ">Mobile Number</label>
                            </div>
                            <input className="bg-transparent text-wafaa-black-2 border text-wafaa-border p-2 px-3 w-100 rounded-3" required name="recipient_mobile" type="tel" placeholder="+971 50 123 4567" />
                        </div>
                    </div>

                    <div className={"font-size-12 text-end pt-3 text-danger " + (customerShareExist ? "d-none" : "d-block")}>Customer does not exist</div>
                </div>

                <div className="bg-wafaa-white-2 shadow-wafaa-bg p-3 pb-0 rounded-3 mt-4">
                    <div className="d-flex align-items-center gap-2 mb-3">
                        <div className="rounded-2 d-flex align-items-center justify-content-center gap" style={{ backgroundColor: "#E8E9F4", width: "30px", height: "30px" }}>
                            <span className="fa-solid fa-dollar-sign text-wafaa-purple font-size-13"></span>
                        </div>
                        <p className="font-size-16 font-weight-800 text-wafaa-black-1 m-0 p-0">Transfer Amount</p>
                    </div>
                    <p className="font-size-14  font-weight-600 m-0 text-wafaa-black-1 mb-1 opacity-75 ">Points to send</p>
                    <div className="bg-wafaa-white-2 m-0 p-0">
                        <div className="input-group justify-content-between m-0 py-2" style={{ border: "1px solid #d3d7e8", borderRadius: "12px" }}>
                            <button type="button" onClick={() => handlePoints(-1)} className="btn font-size-20 font-weight-800   text-wafaa-grey ">
                                -
                            </button>
                            <input
                                name="points"
                                required
                                value={pointsToRedeem}
                                max={customerData.CURRENTPOINTS || 0}
                                min="0"
                                onChange={handleInput}
                                type="number"
                                pattern="\d*"
                                placeholder="Amount(Points)"
                                className="col-4 bg-wafaa-white-2 number-textfield text-wafaa-black-1 border-0 text-center font-size-18 font-weight-600"
                            />
                            <button type="button" onClick={() => handlePoints(1)} className="btn font-size-20 font-weight-800   text-wafaa-grey ">
                                +
                            </button>
                        </div>
                    </div>

                    <div style={{ marginTop: "2.3rem" }}>
                        <div className="position-relative w-100">
                            <input type="range" className="modern-slider w-100"  min="0" max="100" value={rangeValue} onChange={handleRangeValueChange} />
                            <div className="d-flex justify-content-between mt-2 mb-0 text-muted small text-wafaa-grey">
                             {sliderSteps?.map((percentage) => (
                                    <span key={percentage}>{getStepPoints(percentage)}</span>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="mt-4 pb-3">
                        <p className="font-size-14  font-weight-600 m-0 text-wafaa-black-1 mb-1 opacity-75 ">Equivalent Value</p>
                        <div className="bg-wafaa-white-2 rounded-3">
                            <div className="input-group mb-3 justify-content-between py-2" style={{ border: "1px solid #d3d7e8", borderRadius: "12px" }}>
                                <input
                                    name="points_value"
                                    readOnly
                                    value={calculatedPoints + " AED"}
                                    placeholder="Total(AED)"
                                    className="font-size-13 number-textfield py-2 text-center w-100 bg-wafaa-white-2 text-blue-white font-size-16 font-weight-600 py-2 border-0 rounded-2"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="w-100 text-center" style={{ marginBottom: "6rem", marginTop: "15px" }}>
                    <button className="w-100 btn bg-wafaa-purple text-white align-items-center d-flex justify-content-center" style={{ padding: "0.8rem 0" }}>
                        Share Points <span className="ps-2 fas fa-share-nodes"></span>
                    </button>
                </div>
            </form>
            <Navbar activePage="profile" />
        </AnimatedPage>
    );
}

export default SharePoints;
